<template>
  <v-container fluid>
    <v-row class="mb-4">
      <v-col cols="12" sm="4">
        <v-select
          v-model="filtroPostulantes"
          :items="filtrosPostulantes"
          label="Filtrar requerimientos"
          dense
          outlined
        />
      </v-col>
    </v-row>

    <v-row
      v-if="esAdmin"
      class="mb-4"
    >

      <v-col cols="12" md="4">
        <v-select
          v-model="filtrosAdmin.proveedor"
          :items="listaProveedores"
          label="Proveedor"
          clearable
          dense
          outlined
        />
      </v-col>

      <v-col cols="12" md="4">
        <v-select
          v-model="filtrosAdmin.contratista"
          :items="listaContratistas"
          label="Contratista"
          clearable
          dense
          outlined
        />
      </v-col>

      <v-col cols="12" md="4">
        <v-select
          v-model="filtrosAdmin.estado"
          :items="listarEstados"
          label="Estado"
          clearable
          dense
          outlined
        />
      </v-col>

      <v-col cols="12" md="3">
        <v-text-field
          v-model="filtrosAdmin.nrorequerimiento"
          label="N° Requerimiento"
          clearable
          dense
          outlined
          prepend-inner-icon="mdi-magnify"
        />
      </v-col>

    </v-row>

    <v-card
      v-for="reque in requerimientosFiltrados"
      :key="reque.idrequerimiento"
      class="requerimiento-card mb-6"
      outlined
    >
      <!-- HEADER -->
      <v-card-title class="req-header">
        <div>
          <div class="req-title">
            <strong>{{ reque.denominacion.slice(0,3) }}</strong>
            <span class="grey--text"> - {{ reque.empresa_contacto }}</span>
            <v-chip x-small class="ml-1">{{ reque.nombre_categoria }}</v-chip>
          </div>
          <!-- <div class="req-meta">ID: {{ reque.codigo_contrato }}</div> -->
          <div class="req-subtitle">
            <span class="grey--text">{{ detallesTextoServicio(reque.detalles) }} ({{ detallesTexto(reque.detalles) }})</span>
            <v-icon small class="ml-2">mdi-calendar</v-icon>
            {{ formatearFecha(reque.fecha_inicio) }}
          </div>
          <v-btn
            icon
            small
            class="mr-2"
            @click="toggleRequerimiento(reque.idrequerimiento)"
          >
            <v-icon>
              {{
                requerimientosExpandido.includes(reque.idrequerimiento)
                  ? 'mdi-chevron-down'
                  : 'mdi-chevron-right'
              }}
            </v-icon>
          </v-btn>
        </div>

        <v-chip color="blue" small text-color="white">
          {{ postulacionesPendientes(reque.postulaciones).length }} pendientes
        </v-chip>
      </v-card-title>

      <!-- CUERPO -->
      <v-expand-transition>
        <div
          v-show="requerimientosExpandido.includes(reque.idrequerimiento)"
        >
          <v-card-text>
            <v-btn
              color="green"
              dark
              class="mb-2"
              :disabled="!seleccionados[reque.idrequerimiento] || seleccionados[reque.idrequerimiento].length === 0"
              @click="confirmarAprobacionMasiva(reque)"
            >
              Aprobar seleccionados ({{ (seleccionados[reque.idrequerimiento] || []).length }})
            </v-btn>
            <v-simple-table>
              <thead>
                <tr>
                  <th>
                    <v-checkbox
                      v-model="selectAll[reque.idrequerimiento]"
                      @change="toggleSelectAll(reque)"
                      hide-details
                    />
                  </th>
                  <th>Empresa</th>
                  <th>RUC</th>
                  <th>Contacto</th>
                  <th class="text-right">Monto total contratado</th>
				  <th class="text-center">Contratos</th>
				  <th class="text-center">Contratos en curso</th>
				  <th class="text-center">Evaluación</th>
				  <th>Estado</th>
                  <th class="text-right">Acciones</th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="post in postulacionesPendientes(reque.postulaciones)"
                  :key="post.idpostulacion"
                >
                  <td>
                    <v-checkbox
                      v-model="seleccionados[reque.idrequerimiento]"
                      :value="post"
                      hide-details
                    />
                  </td>
                  <td>{{ post.empresa.razonsocial }}</td>
                  <td>{{ post.empresa.ruc }}</td>
                  <td>{{ formatearCelulares(post.empresa.representante_cel) }}</td>
                  <!-- Monto total contratado -->
					<td class="text-right">
					  {{ formatearMonto(post.empresa.monto_contratado) }}
					</td>

					<!-- Cantidad total de contratos -->
					<td class="text-center">
					  {{ post.empresa.contratos || 0 }}
					</td>

					<!-- Cantidad de contratos en curso -->
					<td class="text-center">
					  {{ post.empresa.cantidad_contratos || 0 }}
					</td>

					<!-- Semáforo de evaluación -->
					<td class="text-center">
					  	<v-chip
						  small
						  :color="colorSemaforo(post.empresa.evaluacion_proveedor)"
						  text-color="white"
						>
						  {{ post.empresa.evaluacion_proveedor || 'PENDIENTE' }}
						</v-chip>
					</td>

					<td>
	                    <v-chip small color="orange" text-color="white">
	                      Pendiente
	                    </v-chip>
	                </td>

                  <td class="text-right">
                    <v-btn icon color="green" @click="confirmarAprobacion(post, reque.idrequerimiento)">
                      <v-icon>mdi-check</v-icon>
                    </v-btn>

                    <v-btn icon color="red" @click="confirmarRechazo(post, reque.idrequerimiento)">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </td>
                </tr>

                <tr v-if="postulacionesPendientes(reque.postulaciones).length === 0">
                  <td colspan="9" class="text-center grey--text">
                    No hay postulaciones pendientes
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </div>
      </v-expand-transition>
    </v-card>

    <!-- DIALOGO APROBAR -->
    <v-dialog v-model="dialogAprobar" max-width="420">
      <v-card>
        <v-card-title>Confirmar aprobación</v-card-title>
        <v-card-text>
          ¿Seguro que deseas aprobar esta postulación?
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="dialogAprobar = false">Cancelar</v-btn>
          <v-btn color="green" dark @click="ejecutarAprobacion">Aprobar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOGO RECHAZAR -->
    <v-dialog v-model="dialogRechazar" max-width="600">
      <v-card>
        <v-card-title class="headline">
          Rechazar postulación
        </v-card-title>

        <v-card-text>
          <!-- VISTA TEXTO (bonito) -->
          <div v-if="!editandoMensaje" class="mensaje-preview">
            <p>{{ mensajeRechazo }}</p>

            <v-btn
              text
              small
              color="#0095A9"
              @click="editandoMensaje = true"
            >
              <v-icon left small>mdi-pencil</v-icon>
              Editar mensaje
            </v-btn>
          </div>

          <!-- TEXTAREA (edición) -->
          <v-textarea
            v-else
            v-model="mensajeRechazo"
            label="Mensaje al proveedor"
            outlined
            auto-grow
            rows="4"
            counter="500"
            class="mt-2"
          />

        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn
            text
            color="#9E9E9E"
            @click="dialogRechazar = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="#C05026"
            dark
            :disabled="!mensajeRechazo || mensajeRechazo.length < 20"
            @click="ejecutarRechazo"
          >
            Rechazar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  name: 'PostulacionesAdmin',

  data () {
    return {
      requerimientos: [],
      filtroPostulantes: 'CON',
      filtrosPostulantes: [
        { text: 'Con postulantes', value: 'CON' },
        { text: 'Sin postulantes', value: 'SIN' },
        { text: 'Todos', value: 'TODOS' }
      ],

      dialogAprobar: false,
      dialogRechazar: false,
      mensajeRechazo: '',
      editandoMensaje: false,

      postSeleccionado: null,
      reqSeleccionado: null,
      seleccionados: {},
      selectAll: {},
      filtrosAdmin: {
        proveedor: null,
        contratista: null,
        estado: null,
        nrorequerimiento: null,
      },
      requerimientosExpandido: [],

      esAdmin: false,
    }
  },

  mounted () {
    this.listarRequerimientos()
  },

  created () {
    this.idusuario = localStorage.getItem('idusuario')
    this.rol = localStorage.getItem('rol')
    this.empresaid = localStorage.getItem('empresa')
    this.empresaid = this.empresaid ? Number(this.empresaid) : null
    this.esAdmin = this.rol === 'ADMINISTRADOR'
  },

  computed: {
    listaProveedores () {

      return [...new Set(

        this.requerimientos.flatMap(r =>

          this.postulacionesPendientes(
            r.postulaciones
          ).map(p =>

            p.empresa?.razonsocial ||
            p.empresa?.razon_social

          )

        )

      )]
      .filter(Boolean)
      .sort()

    },

    listaContratistas () {

      return [...new Set(

        this.requerimientos
          .map(r => r.empresa_contacto)

      )]
      .filter(Boolean)
      .sort()

    },

    listarEstados () {

      return [...new Set(

        this.requerimientos.flatMap(r =>

          this.postulacionesPendientes(
            r.postulaciones
          ).map(p => p.estado)

        )

      )]
      .filter(Boolean)
      .sort()

    },
    requerimientosFiltrados () {

      return this.requerimientos.filter(r => {

        const visibles = this.postulacionesPendientes(
          r.postulaciones
        )

        // CON / SIN / TODOS
        if (
          this.filtroPostulantes === 'CON' &&
          visibles.length === 0
        ) return false

        if (
          this.filtroPostulantes === 'SIN' &&
          visibles.length > 0
        ) return false


        // PROVEEDOR
        if (this.filtrosAdmin.proveedor) {

          const existeProveedor = visibles.some(p =>

            (p.empresa?.razonsocial ||
             p.empresa?.razon_social)

            === this.filtrosAdmin.proveedor

          )

          if (!existeProveedor)
            return false
        }


        // CONTRATISTA
        if (
          this.filtrosAdmin.contratista &&
          r.empresa_contacto !==
          this.filtrosAdmin.contratista
        ) {
          return false
        }


        // ESTADO
        if (this.filtrosAdmin.estado) {

          const existeEstado = visibles.some(
            p => p.estado ===
            this.filtrosAdmin.estado
          )

          if (!existeEstado)
            return false
        }

        if (this.filtrosAdmin.nrorequerimiento) {
          const filtro = this.filtrosAdmin.nrorequerimiento
            .toString()
            .trim()

          const nroRequerimiento = r.denominacion
            ?.toString()
            .match(/^(\d{3})/)?.[1]

          if (!nroRequerimiento?.includes(filtro)) {
            return false
          }
        }

        return true

      })

    }
  },

  methods: {
    listarRequerimientos () {
      axios.get('api/Requerimientos/Listar', {
          params: {
            idusuario: this.idusuario
          }
        })
        .then(res => { 
          this.requerimientos = res.data;
          this.seleccionados = {};
          this.selectAll = {};
          this.requerimientos.forEach(r => {
            if (!this.seleccionados[r.idrequerimiento]) {
              this.$set(this.seleccionados, r.idrequerimiento, [])
            }
            if (!this.selectAll[r.idrequerimiento]) {
              this.$set(this.selectAll, r.idrequerimiento, false)
            }
          }); })
    },

    postulacionesPendientes (lista) {
      return (lista || []).filter(p => p.estado === 'REGISTRADO')
    },

    confirmarAprobacion (post, idreq) {
      this.postSeleccionado = post
      this.reqSeleccionado = idreq
      this.dialogAprobar = true
    },

    // confirmarRechazo (post, idreq) {
    //   this.postSeleccionado = post
    //   this.reqSeleccionado = idreq
    //   this.mensajeRechazo = ''
    //   this.dialogRechazar = true
    // },

    // ejecutarAprobacion () {
    //   this.actualizarEstado('EN_POSTULACION')
    //   this.dialogAprobar = false
    // },

    ejecutarRechazo () {
      this.actualizarEstado('RECHAZADO', this.mensajeRechazo)
      this.dialogRechazar = false
    },

    actualizarEstado (estado, comentario = null) {
      if (!this.postSeleccionado) return
      axios.put('api/PostulacionEmpresas/Actualizar', {
        idpostulacion: this.postSeleccionado.idpostulacion,
        idrequerimiento: this.reqSeleccionado,
        id_empresa: this.postSeleccionado.idempresa,
        estado,
        comentario: comentario
      }).then(() => {
        this.listarRequerimientos()
      })
    },

    formatearCelulares (cel) {
      return cel ? cel.toString().split(/[\s,;]+/).join(' / ') : ''
    },

    separarCorreos (correos) {
      return correos ? correos.toString().split(/[\s,;]+/) : []
    },

    confirmarRechazo (post, idreq) {
      this.postSeleccionado = post
      this.reqSeleccionado = idreq
      this.mensajeRechazo =
        `Tras la revisión de la postulación presentada, se informa que la empresa no cumple actualmente con los rubros exigidos para el presente requerimiento.

Se recomienda actualizar la información de rubros correspondiente a fin de participar en futuras convocatorias. Para ello, deberá apersonarse a nuestras oficinas y realizar la actualización respectiva.

Agradecemos su comprensión.`
      this.dialogRechazar = true
    },

    toggleSelectAll(reque) {
      const id = reque.idrequerimiento
      const pendientes = this.postulacionesPendientes(reque.postulaciones)

      if (this.selectAll[id]) {
        this.seleccionados[id] = [...pendientes]
      } else {
        this.seleccionados[id] = []
      }
    },
    confirmarAprobacionMasiva (reque) {
      this.reqSeleccionado = reque.idrequerimiento
      this.postSeleccionado = null
      this.dialogAprobar = true
    },
    ejecutarAprobacion () {
      const lista = this.seleccionados[this.reqSeleccionado] || []

      if (lista.length > 0) {
        this.aprobarMasivo()
      } else if (this.postSeleccionado) {
        this.actualizarEstado('EN_POSTULACION')
      }

      this.dialogAprobar = false
    },
    aprobarMasivo () {
      // const requests = this.seleccionados.map(post => {
      //   return axios.put('api/PostulacionEmpresas/Actualizar', {
      //     idpostulacion: post.idpostulacion,
      //     idrequerimiento: this.reqSeleccionado || post.idrequerimiento,
      //     id_empresa: post.idempresa,
      //     estado: 'EN_POSTULACION'
      //   })
      // })

      // Promise.all(requests).then(() => {
      //   this.seleccionados = []
      //   this.selectAll = false
      //   this.listarRequerimientos()
      // })
      const id = this.reqSeleccionado
      const lista = this.seleccionados[id] || []

      const requests = lista.map(post => {
        return axios.put('api/PostulacionEmpresas/Actualizar', {
          idpostulacion: post.idpostulacion,
          idrequerimiento: id,
          id_empresa: post.idempresa,
          estado: 'EN_POSTULACION'
        })
      })

      Promise.all(requests).then(() => {
        this.seleccionados = {}
        this.selectAll = {}
        this.listarRequerimientos()
      })
    },
    detallesTexto(detalles) {
      if (!detalles || !detalles.length) return ''
      return detalles.map(d => d.detalle).join(', ')
    },
    detallesTextoServicio(detalles) {
      if (!detalles || !detalles.length) return ''
      return detalles.map(d => d.servicio).join(', ')
    },
    formatearFecha(fecha){
      if(!fecha) return ''
      return new Date(fecha).toLocaleDateString()
    },
    toggleRequerimiento (id) {
      const index = this.requerimientosExpandido.indexOf(id)

      if (index !== -1) {
        this.requerimientosExpandido.splice(index, 1)
      } else {
        this.requerimientosExpandido.push(id)
      }
    },
    formatearMonto (monto) {
	  const valor = Number(monto)

	  if (isNaN(valor)) {
	    return '$ 0.00'
	  }

	  return new Intl.NumberFormat('en-US', {
	    style: 'currency',
	    currency: 'USD',
	    minimumFractionDigits: 2
	  }).format(valor)
	},
	colorSemaforo (estado) {
	  switch (estado) {
	    case 'CUMPLE':
	      return 'green'

	    case 'NO_CUMPLE':
	      return 'red'

	    default:
	      return 'orange'
	  }
	},
  }
}
</script>

<style scoped>
.requerimiento-card {
  border-radius: 14px;
}

.req-header {
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
}
.req-meta {
  font-size: 12px;
  color: #6b7280;
}
.mensaje-preview {
  background: #f9fafb;
  border-left: 4px solid #FDB714;
  padding: 14px;
  border-radius: 6px;
  font-size: 14px;
  line-height: 1.5;
  color: #374151;
  text-align: justify;
  line-height: 1.5;
}
.req-title {
  font-size: 18px;
  font-weight: 700;
}
.req-subtitle {
  font-size: 14px;
  color: #6b7280;
}
</style>
